const pickGraphqlError = (error) => {
	if (!error) return null;

	if (Array.isArray(error)) {
		return error[0] ?? null;
	}

	if (Array.isArray(error.graphQLErrors) && error.graphQLErrors.length) {
		return error.graphQLErrors[0];
	}

	if (Array.isArray(error.errors) && error.errors.length) {
		return error.errors[0];
	}

	if (error.extensions || error.message) {
		return error;
	}

	return null;
};

export const getGraphqlErrorDetails = (
	error,
	fallback = 'Произошла ошибка',
) => {
	const graphQLError = pickGraphqlError(error);
	const message = graphQLError?.message || error?.message || fallback;
	const debugMessage = graphQLError?.extensions?.debugMessage;

	return {
		message,
		debugMessage:
			debugMessage && debugMessage !== message ? debugMessage : null,
	};
};

export class GraphqlRequestError extends Error {
	constructor({ message, debugMessage = null } = {}) {
		super(message || 'Произошла ошибка');
		this.name = 'GraphqlRequestError';
		this.debugMessage = debugMessage;
	}
}

export const createGraphqlRequestError = (
	error,
	fallback = 'Произошла ошибка',
) => {
	const details = getGraphqlErrorDetails(error, fallback);

	return new GraphqlRequestError(details);
};

/** @deprecated use getGraphqlErrorDetails / createGraphqlRequestError */
export const getGraphqlErrorMessage = (error, fallback = 'Произошла ошибка') => {
	const { message, debugMessage } = getGraphqlErrorDetails(error, fallback);

	if (!debugMessage) return message;

	return `${message}\n\n${debugMessage}`;
};

export const normalizeServerError = (error) => {
	if (!error) return null;

	if (typeof error === 'string') {
		return { message: error, debugMessage: null };
	}

	if (
		error instanceof Error ||
		Array.isArray(error) ||
		Array.isArray(error?.graphQLErrors) ||
		Array.isArray(error?.errors) ||
		error?.extensions
	) {
		const details = getGraphqlErrorDetails(error);

		return {
			message: details.message,
			debugMessage:
				details.debugMessage ||
				error.debugMessage ||
				null,
		};
	}

	if (typeof error === 'object') {
		return {
			message: error.message || error.statusText || 'Произошла ошибка',
			debugMessage: error.debugMessage || null,
		};
	}

	return { message: String(error), debugMessage: null };
};
